import { useMemo, useState } from 'react';
import { calculateSecondaryPanelPosition } from 'components/pages/Planner/PlannerLineActions/calculateSecondaryPanelPosition';
import PlannerSecondaryPanel from 'components/pages/Planner/PlannerSecondaryPanel';
import ObjectiveFilters from './ObjectiveFilters';
import ObjectiveName from './ObjectiveName';
import { ObjectivePanelProps } from './ObjectivePanel.types';
import ObjectiveTargets from './ObjectiveTargets';

const ObjectivePanel: React.FC<ObjectivePanelProps> = ({
  activeObjective,
  isChange,
  initialObjectiveState,
  onClose,
  onConfirm,
}) => {
  const { budget, frames, impressions, locations, formats, tags, frameList, poi } = activeObjective;

  const [nameError, setNameError] = useState('');

  const isToleranceError = useMemo(() => {
    return (
      budget.greenTolerance > budget.orangeTolerance ||
      frames.greenTolerance > frames.orangeTolerance ||
      impressions.greenTolerance > impressions.orangeTolerance
    );
  }, [budget, frames, impressions]);

  const isMandatoryTargetSelection = useMemo(
    () =>
      (budget.value || frames.value || impressions.value) &&
      (locations.length > 0 ||
        formats.length > 0 ||
        tags.length > 0 ||
        frameList.listFiles.length > 0 ||
        frameList.routeFrameCodes.length > 0 ||
        poi.length > 0),
    [activeObjective],
  );

  if (!initialObjectiveState) return null;

  return (
    <PlannerSecondaryPanel
      title={initialObjectiveState.name}
      onSubmit={onConfirm}
      onCancel={onClose}
      isDisabled={!isMandatoryTargetSelection || !isChange || !!nameError || isToleranceError}
      customStyles={calculateSecondaryPanelPosition({ width: 400 })}
    >
      <div className="flex flex-col gap-y-8">
        <ObjectiveName error={nameError} onError={(newError: string) => setNameError(newError)} />
        <ObjectiveFilters />
        <ObjectiveTargets />
      </div>
    </PlannerSecondaryPanel>
  );
};

export default ObjectivePanel;
